





















import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import { Location } from "vue-router";

@Component
export default class InvestmentAccountLink extends Vue {

  @Prop({required: true})
  routeToAccount: Location;

  @Prop({required: true})
  label: string;

  @Prop({required: false})
  balance: number;

  get accountBalance (): string {
    if (this.balance) {
      return formatCurrency(this.balance);
    }

    return "0.00";
  }
}
